export function project(s1, t1, s2, t2, v) {
  return t1 + ((v - s1) * (t2 - t1)) / (s2 - s1);
}

export function projectLimit(s1, t1, s2, t2, v) {
  if (t1 < t2) {
    return Math.min(t2, Math.max(t1, project(s1, t1, s2, t2, v)));
  } else {
    return Math.min(t1, Math.max(t2, project(s1, t1, s2, t2, v)));
  }
}
